import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = /*#__PURE__*/_createTextVNode("icons");
const _hoisted_2 = {
  class: "grid grid-cols-3 gap-3 my-2"
};
const _hoisted_3 = {
  class: "text-xs"
};
import DefaultInGameLayout from "@/modules/base/layouts/DefaultInGameLayout.vue";
import Icon from "@/modules/vue/components/Icon.vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'IconsPage',
  setup(__props) {
    const icons = ref(Object.keys(IconEnum));
    return (_ctx, _cache) => {
      return _openBlock(), _createBlock(DefaultInGameLayout, null, {
        title: _withCtx(() => [_hoisted_1]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(icons.value, icon => {
          return _openBlock(), _createElementBlock("div", {
            key: icon,
            class: "flex flex-col items-center rounded bg-slate-50 p-2"
          }, [_createVNode(Icon, {
            icon: icon,
            class: "mb-2"
          }, null, 8, ["icon"]), _createElementVNode("div", _hoisted_3, _toDisplayString(icon), 1)]);
        }), 128))])]),
        _: 1
      });
    };
  }
});